import React, { useState, useEffect } from 'react';
import { getLocalProfile, saveLocalProfile } from '../services/api';
import './ProfilePage.css';

function ProfilePage({ kiteProfile }) {
  const [customFields, setCustomFields] = useState([]);
  const [customOpen, setCustomOpen] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');

  useEffect(() => {
    getLocalProfile()
      .then(data => setCustomFields(data.customFields || []))
      .catch(() => setCustomFields([]));
  }, []);

  const addField = () =>
    setCustomFields(prev => [...prev, { label: '', value: '' }]);

  const removeField = (i) =>
    setCustomFields(prev => prev.filter((_, idx) => idx !== i));

  const updateField = (i, key, val) =>
    setCustomFields(prev => prev.map((f, idx) => idx === i ? { ...f, [key]: val } : f));

  const handleSave = async () => {
    setSaving(true);
    setSaveMsg('');
    try {
      await saveLocalProfile({ customFields });
      setSaveMsg('Saved successfully');
    } catch {
      setSaveMsg('Failed to save');
    } finally {
      setSaving(false);
      setTimeout(() => setSaveMsg(''), 3000);
    }
  };

  const p = kiteProfile || {};

  return (
    <div className="profile-page">

      {/* Kite Profile Info */}
      <div className="profile-card">
        <div className="profile-card-header">
          <div className="profile-avatar">{p.user_name?.[0]?.toUpperCase() || '?'}</div>
          <div>
            <div className="profile-fullname">{p.user_name || '—'}</div>
            <div className="profile-id">Kite ID: {p.user_id || '—'}</div>
          </div>
        </div>

        <div className="profile-fields">
          <div className="profile-field">
            <span className="field-label">Email</span>
            <span className="field-value">{p.email || '—'}</span>
          </div>
          <div className="profile-field">
            <span className="field-label">Phone</span>
            <span className="field-value">{p.phone || p.meta?.mobile_number || '—'}</span>
          </div>
          <div className="profile-field">
            <span className="field-label">Kite User ID</span>
            <span className="field-value">{p.user_id || '—'}</span>
          </div>
          <div className="profile-field">
            <span className="field-label">Broker</span>
            <span className="field-value">{p.broker || 'Zerodha'}</span>
          </div>
          <div className="profile-field">
            <span className="field-label">Account Type</span>
            <span className="field-value">{p.user_type || '—'}</span>
          </div>
        </div>
      </div>

      {/* Custom Fields */}
      <div className="profile-card">
        <div className="custom-section-header" onClick={() => setCustomOpen(o => !o)}>
          <span className="custom-section-title">Custom Fields</span>
          <div className="custom-section-controls">
            <span className="chevron">{customOpen ? '▲' : '▼'}</span>
          </div>
        </div>

        {customOpen && (
          <div className="custom-section-body">
            {customFields.length === 0 && (
              <p className="no-custom">No custom fields yet. Click + Add Field to add one.</p>
            )}
            {customFields.map((field, i) => (
              <div className="custom-field-row" key={i}>
                <input
                  className="custom-input label-input"
                  placeholder="Label"
                  value={field.label}
                  onChange={e => updateField(i, 'label', e.target.value)}
                />
                <input
                  className="custom-input value-input"
                  placeholder="Value"
                  value={field.value}
                  onChange={e => updateField(i, 'value', e.target.value)}
                />
                <button className="remove-field-btn" onClick={() => removeField(i)} title="Remove">✕</button>
              </div>
            ))}

            <div className="custom-actions">
              <button className="add-field-btn" onClick={addField}>+ Add Field</button>
              <div className="save-row">
                {saveMsg && <span className={`save-msg ${saveMsg.includes('Failed') ? 'error' : 'success'}`}>{saveMsg}</span>}
                <button className="save-btn" onClick={handleSave} disabled={saving}>
                  {saving ? 'Saving…' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
}

export default ProfilePage;
